// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { observer } from "mobx-react-lite";
import React from "react";

import { pluralizeWord } from "~utils";

import { useRootStore } from "../../components/StoreProvider";
import { CaseloadSelect } from "../CaseloadSelect";
import { Heading, SubHeading } from "../sharedComponents";
import { WorkflowsNavLayout } from "../WorkflowsLayouts";
import MilestonesCaseloadView from "./MilestonesCaseloadView";

const WorkflowsMilestones = observer(
  function WorkflowsMilestones(): React.ReactElement<any> | null {
    const {
      workflowsStore: {
        justiceInvolvedPersonTitle,
        searchStore: { isTypesenseSearchEnabled },
      },
    } = useRootStore();

    const title = pluralizeWord({ term: justiceInvolvedPersonTitle });

    // With the typesense search FV, the header + subheader render above the
    // search bar (consistent with the other caseload pages); otherwise they
    // render below it, as before.
    const header = (
      <>
        <Heading>Congratulate your {title} on their progress</Heading>
        <SubHeading>
          Send a text message to celebrate your {title}&apos; milestones. This
          list will refresh every month.
        </SubHeading>
      </>
    );

    return (
      <WorkflowsNavLayout>
        {isTypesenseSearchEnabled && header}
        <CaseloadSelect />
        {!isTypesenseSearchEnabled && header}
        <MilestonesCaseloadView />
      </WorkflowsNavLayout>
    );
  },
);

export default WorkflowsMilestones;
